import classes from './NavBar.module.css';
import NavMenuItem, { TNavMenuItem } from './NavMenuItem';

export type TMenuLink = Omit<TNavMenuItem, 'onToggleMenu'>;

export type TNavMenuList = {
  menuLinks: TMenuLink[];
} & Pick<TNavMenuItem, 'onToggleMenu'>;

function NavMenuList({ menuLinks, onToggleMenu }: TNavMenuList) {
  return (
    <ul className={classes.menu_list} data-testid="navBar_menuList">
      {menuLinks.map((item, index) => (
        <NavMenuItem
          key={`${item.to}-${index}` || item.title}
          {...{ ...item, onToggleMenu }}
        />
      ))}
    </ul>
  );
}

export default NavMenuList;
